import SpriteSymbol from "../../../../node_modules/_svg-baker-runtime@1.4.7@svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/_svg-sprite-loader@6.0.9@svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "close",
  "use": "close-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"close\"><defs><style></style></defs><path d=\"M602.478 488.74L1000.74 90.479 910.19 0 512 398.19 113.81 0 23.26 90.478 421.521 488.74 5.12 905.07l90.55 90.55L512 579.219l416.33 416.403 90.55-90.551-416.402-416.33z\" /></symbol>"
});
var result = sprite.add(symbol);
export default "#" + symbol.id